module.exports = __webpack_public_path__ + "static/images/leaflet-measure/start_@2X.png";